import React from "react";
import createReactClass from "create-react-class";
import Name from "okpay/components/fields/Name";
import ZipCode from "okpay/components/fields/ZipCode";
import CardNumber from "okpay/components/fields/CardNumber";
import SecurityCode from "okpay/components/fields/SecurityCode";
import Expiration from "okpay/components/fields/Expiration";
import Address from "okpay/components/fields/Address";
import PurchaseButton from "okpay/components/PurchaseButton";
import Str from "shared/components/Str";
import _str from "shared/util/_str";

import "./cardform.scss";

const CardForm = createReactClass({
	displayName: "CardForm",
	mixins: [React.addons.PureRenderMixin],

	render() {
		let addressField;
		let billingError;
		let buttonText;

		if (this.props.showAddress) {
			addressField = (
				<Address
					hasSubmitted={this.props.hasSubmitted}
					value={this.props.address}
					error={this.props.addressError}
				/>
			);
		}

		// sometimes, the error will have HTML in it, and it's unavoidable.
		if (this.props.billingError && this.props.hasSubmitted) {
			const html = { __html: this.props.billingError };
			billingError = (
				<div className="okpay-cardform-error" dangerouslySetInnerHTML={html} />
			);
		}

		if (this.props.productId === "update") {
			buttonText = <Str>Update card</Str>;
		} else {
			buttonText = <Str>Confirm purchase</Str>;
		}

		return (
			<div className="okpay-cardform">
				<div className="okpay-cardform-header">
					<h1 className="okpay-cardform-heading">
						{_str("Enter your billing information")}
					</h1>
				</div>
				{billingError}
				<div className="okpay-cardform-fields">
					<Name
						isSubmitting={this.props.isSubmitting}
						hasSubmitted={this.props.hasSubmitted}
						value={this.props.name}
						error={this.props.nameError}
					/>
					<CardNumber
						cardType={this.props.cardType}
						isSubmitting={this.props.isSubmitting}
						hasSubmitted={this.props.hasSubmitted}
						value={this.props.cardNumber}
						error={this.props.cardNumberError}
					/>
					{addressField}
					<SecurityCode
						isSubmitting={this.props.isSubmitting}
						hasSubmitted={this.props.hasSubmitted}
						value={this.props.securityCode}
						error={this.props.securityCodeError}
					/>
					<Expiration
						isSubmitting={this.props.isSubmitting}
						hasSubmitted={this.props.hasSubmitted}
						value={this.props.expiration}
						error={this.props.expirationError}
					/>
					<ZipCode
						isSubmitting={this.props.isSubmitting}
						hasSubmitted={this.props.hasSubmitted}
						value={this.props.zipCode}
						error={this.props.zipCodeError}
						isUS={this.props.isUS}
					/>
				</div>
				<PurchaseButton
					rightSide={React.createElement(
						"div",
						{ className: "okpay-security" },
						<i className="okicon i-lock-closed" />,
						<Str>Secure</Str>,
					)}
				>
					{buttonText}
				</PurchaseButton>
			</div>
		);
	},
});

export default CardForm;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/CardForm.jsx